import { type FC } from 'react';

import { type CarouselSlide } from '@editor2/types/pageElements';

import LibsSlide from '@soomo/lib/components/pageElements/Carousel/Slide';
import ShadowDOMRoot from '@soomo/lib/components/ShadowDOMRoot';
import { type CarouselTheme } from '@soomo/lib/types/index';

interface Props {
	slide: CarouselSlide;
	theme: CarouselTheme;
	color: string;
	logo_url?: string;
	logo_alt?: string;
	scale: number;
}

const WIDTH = 328;
const HEIGHT = 410;

const SlidePreview: FC<Props> = (props) => {
	const { slide, theme, color, logo_url, logo_alt, scale } = props;

	return (
		<div
			style={{
				transform: `scale(${scale})`,
				transformOrigin: 'top left',
				width: `${scale * WIDTH}px`,
				height: `${scale * HEIGHT}px`
			}}
			className="slide-preview">
			<ShadowDOMRoot mode="open">
				<div
					style={{
						width: `${WIDTH}px`,
						height: `${HEIGHT}px`,
						container: 'slide-preview / size'
					}}>
					<LibsSlide
						slide={slide}
						theme={theme}
						color={color}
						logo_url={logo_url}
						logo_alt={logo_alt}
						textProps={{ citationReferences: {} }}
					/>
				</div>
			</ShadowDOMRoot>
		</div>
	);
};

export default SlidePreview;
